import PaginationContainer from "../../../Components/BonusUi/Paginations/Paginations"

const Paginations = () => {
  return (
    <div className='page-body'>
      <PaginationContainer />
    </div>
  )
}

export default Paginations